import React, { useContext, useEffect, useRef, useState } from 'react';
import { CompanyContext, ParentContext, CountContext } from '../../layouts/Dashboard/LayoutDashboard';
import { Modal, Button, Form, Col, Row, FloatingLabel } from 'react-bootstrap';
//import Select, { createFilter } from 'react-select';
// import CustomOption from '../../utils/Elements/CustomOption';
import AsyncSelect from 'react-select/async';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import '../Pages.css';

export const ContactForm = ({ showModal, closeModal, contactInfo }) => {
  const internalNotesRef = useRef(null);
  const api = process.env.REACT_APP_API_ENDPOINT;
  const associationsEndpoint = `${api}/v1/associations/company`;
  const individualsEndpoint = `${api}/v1/individuals`;
  const companySearch = `${api}/v1/companies/search?searchterm=`;
  
  const { setContactCount } = useContext(CountContext);
  const { selectedParentID } = useContext(ParentContext);
  const { selectedCompanyID, allCompanies } = useContext(CompanyContext);

  const [validated, setValidated] = useState(false);
  const [identity, setIdentity] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [duplicateEmail, setDuplicateEmail] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const [profile, setProfile] = useState({
    id: 0,
    name: "",
    email: "",
    title: "",
    phone: "",
    cell: "",
    //account: "",
    association: null, //the currently selected association
    internalNotes: "",
    inactive: false,
  });
  const [associations, setAssociations] = useState([]); //all company Associations for this individual

  const getStoredToken = () => {
    return localStorage.getItem('token');
  };

  const storedToken = getStoredToken();

  const clearProfile = () => {
    setAssociations([]);
    setProfile({
      id: 0,
      name: "",
      email: "",
      title: "",
      phone: "",
      cell: "",
      //account: "",
      association: null,
      internalNotes: "",
      inactive: false,
    });
  };

  const fetchAssociations = async () => {

    setAssociations([]);

    if (contactInfo && contactInfo.IndividualId) {
      try {
        const response = await fetch(associationsEndpoint + '/' + contactInfo.IndividualId, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            EmployeeUID: identity.sub,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          setAssociations(data);
        } else {
          console.error('Failed to fetch associations');
        }
      } catch (error) {
        console.error('Failed to fetch associations', error);
      }
    }

  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: checked,
    }));
  };

  const handleProfileChange = (event) => {
    const { name, value } = event.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };

  const handleCompanyAssociationChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "association": value,
    }));
  };

  const deleteAssociation = (ndx) => {
    let l = associations.map(a => ({ ...a }));
    l.splice(ndx, 1);
    setAssociations(l);
  };

  const setDefaultAssociation = (ndx) => {
    console.log("setDefaultAssociation= " + ndx);

    let l = associations.map(a => ({ ...a }));

    for (var i = 0; i < l.length; i++) {
      l[i].isDefault = false;
    }
    l[ndx].isDefault = true;
    
    setAssociations(l);


  };

  const addAssociation = () => {

    //add the entry to the sorted list
    if (associations.length === 0) {
      associations.push(profile.association);
    } else {
      let didWork = false;
      for (let i = 0; i < associations.length; i++) {
        //ignore the C: or P: part for alpha compare
        //if (associations[i].label > profile.association.label) {
        if (associations[i].label.substring(3) > profile.association.label.substring(3)) {
          associations.splice(i, 0, profile.association)
          didWork = true;
          break;
        }
      }
      if (!didWork) associations.push(profile.association);
    }

    setAssociations(associations);

    //this will clear the company dropdown
    setProfile((prevProfile) => ({
      ...prevProfile,
      association: null
,
    }));

  };

  let internalNotesTimeout = null;
  const addInternalNotesTimeStamp = () => {
    const ts = new Date();
    const tsFormatted = `${ts.toLocaleDateString()} ${ts.toLocaleTimeString()} - `;
    setProfile((prevProfile) => ({
      ...prevProfile,
      internalNotes: `${tsFormatted}\n${prevProfile.internalNotes}`,
    }));
    if (internalNotesTimeout) {
      clearTimeout(internalNotesTimeout);
    }
    internalNotesTimeout = setTimeout(() => {
      internalNotesRef.current.selectionStart = tsFormatted.length;
      internalNotesRef.current.selectionEnd = tsFormatted.length;
      internalNotesRef.current.focus();
    }, 50);
  };

  const validateEmail = () => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    let emailIsValid = !!emailRegex.exec(profile.email);
    return emailIsValid;
  };

  const showFailedMsg = () => {
    toast.error("Failed to update contact", {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 5000,
      paueOnHover: true,
      theme: 'colored'
    });
  };

  const submitContact = async () => {

    const payload = {
      EmployeeUID: identity.sub,
      SelectedParentID: selectedParentID,
      SelectedCompanyID: selectedCompanyID,
      IndividualId: editMode ? profile.id : 0,
      IndividualName: profile.name,
      IndividualTitle: profile.title,
      IndividualEmail: profile.email,
      IndividualPhone: profile.phone,
      IndividualCell: profile.cell,
      InternalNotes: profile.internalNotes,
      CompanyAssociations: associations, //pass in all the associations and the backend will figure out adds and drops
      Inactive: profile.inactive,
    }

    console.log(payload);

    if (!validateEmail()) {
      setInvalidEmail(true);
      return;
    } else {
      setInvalidEmail(false);
    }

    try {

      const response = await fetch(individualsEndpoint, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        const data = await response.json();

        console.log(data);

        if (data.Success) {

          setDuplicateEmail(false);
          setContactCount(data.UnfilteredCount);

          toast.success(editMode ? "Contact Updated!" : "Contact Added!", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            paueOnHover: true,
            theme: 'colored'
          });

          closeModal();

        } else if (data.DuplicateEmail) {

          setDuplicateEmail(true);

        } else {
          showFailedMsg();
        }

      } else {
        showFailedMsg();
      }

    } catch (error) {
      showFailedMsg();
    }

  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity()) {
      await submitContact();
    }
    setValidated(true); //not sure about the placement of this

  };

  //handle one-time startup initializations
  useEffect(() => {

    const fetchAccount = async () => {
      try {
        const identity = jwtDecode(storedToken);
        setIdentity(identity);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (storedToken) {
      fetchAccount();
    } else {
      console.log('Token not found in localStorage');
    }

  }, [])

  //handle open and close modal initializations
  useEffect(() => {

    if (showModal && storedToken) {
      //modal opening
      if (contactInfo && Object.keys(contactInfo).length > 0) {
        //edit mode
        setEditMode(true);
        setProfile((prevProfile) => ({
          ...prevProfile,
          id: contactInfo.IndividualId,
          name: contactInfo.IndividualName,
          email: contactInfo.IndividualEmail,
          title: contactInfo.IndividualTitle,
          phone: contactInfo.IndividualPhone,
          cell: contactInfo.IndividualCell,
          account: contactInfo.IndividualAccount,
          association: null,
          internalNotes: contactInfo.InternalNotes,
          inactive: false,
        }));

        fetchAssociations();

      } else {
        //create mode
        setEditMode(false);

        let association = 0;
        let associationName = "";

        if (!selectedCompanyID) {
          //no company is selected but there is only 1 company in the filtered-by-parent company list, so use it
          if (allCompanies && allCompanies.length === 1) {
            association = allCompanies[0].CustomerId;
            associationName = allCompanies[0].CustomerDisplayName;
          }
        } else {
          association = selectedCompanyID;
          associationName = allCompanies.find(x => x.value === selectedCompanyID).label;
        }

        let a = [];
        if (association && associationName) {
          a.push({ "value": association, "label": associationName });
        }
        setAssociations(a);

        setProfile((prevProfile) => ({
          ...prevProfile,
          id: 0,
          name: "",
          email: "",
          title: "",
          phone: "",
          cell: "",
          account: "",
          association: null,
          internalNotes: "",
          inactive: false,
        }));
      }

      //fetchAssociations();

    } else {
      //modal closing
      setDuplicateEmail(false);
      setInvalidEmail(false);
      clearProfile();
      setValidated(false);
    }

  }, [showModal]);

  const loadCompanyOptions = async (searchterm) => {

    let results = [];

    const response = await fetch(companySearch + searchterm, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };


  return (
    <Modal show={showModal} onHide={closeModal} dialogClassName="contact-form-modal" backdrop="static">
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          {/*<Modal.Title>{editMode ? 'Edit Contact ' : 'Add New Contact'}</Modal.Title>*/}
          <Modal.Title>{editMode ? (contactInfo && contactInfo.IndividualName ? contactInfo.IndividualName : 'Edit Contact') : 'Add New Contact'}</Modal.Title>
          {editMode ? (
            <div className="modal-header-checkbox-container">



              <label className="modal-header-checkbox-label" htmlFor="inactive">Inactive</label>
              <input className="modal-header-checkbox" type="checkbox" name="inactive" id="inactive" checked={profile.inactive} onChange={handleCheckboxChange} />
            </div>
          ) : (null)}
        </Modal.Header>
        <Modal.Body>

          {/*Row 1*/}
          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="name" >
              <FloatingLabel controlId="name" label="Individual Name" className="w-100 required">
                <Form.Control name='name' type="text" placeholder="Individual Name" required value={profile.name} onChange={handleProfileChange} />
                <Form.Control.Feedback type="invalid">Individual Name is required.</Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Row>

          {/*Row 2*/}
          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="title">
              <FloatingLabel controlId="title" label="Individual Title" className="w-100">
                <Form.Control name='title' type="text" placeholder="Individual Title" value={profile.title} onChange={handleProfileChange} />
              </FloatingLabel>
            </Form.Group>
          </Row>

          {/*Row 3
                  isInvalid={duplicateEmail || invalidEmail}
                  required
                  isInvalid={duplicateEmail}
                  https://stackoverflow.com/questions/71521972/custom-validation-in-react-bootstrap-forms-not-working
          */}
          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="email">
              <FloatingLabel controlId="email" label="Individual Email" className="w-100 required">
                <Form.Control
                  name='email'
                  type="text"
                  required
                  isInvalid={duplicateEmail || invalidEmail}
                  placeholder="Individual Email"
                  value={profile.email}
                  onChange={handleProfileChange}
                />
                <Form.Control.Feedback type="invalid">{invalidEmail ? 'Email is invalid' : (duplicateEmail ? 'Email is already in use.' : 'Individual Email is required.')}</Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Row>

          {/*Row 4*/}
          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="phone">
              <FloatingLabel controlId="phone" label="Individual Phone" className="w-100">
                <Form.Control name='phone' type="text" placeholder="Individual Phone" value={profile.phone} onChange={handleProfileChange} />
              </FloatingLabel>
            </Form.Group>
          </Row>

          {/*Row 5*/}
          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="cell">
              <FloatingLabel controlId="cell" label="Individual Cell" className="w-100">
                <Form.Control name='cell' type="text" placeholder="Individual Cell" value={profile.cell} onChange={handleProfileChange} />
              </FloatingLabel>
            </Form.Group>
          </Row>

          {/*Row X*/}
          {/*<Row className='mb-2'>*/}
          {/*  <Form.Group as={Col} md="12" controlId="account">*/}
          {/*    <FloatingLabel controlId="account" label="Account" className="w-100">*/}
          {/*      <Form.Control name='account' type="text" placeholder="Individual Account" value={profile.account} onChange={handleProfileChange} />*/}
          {/*    </FloatingLabel>*/}
          {/*  </Form.Group>*/}
          {/*</Row>*/}

          {/*Row 6*/}
          <Row className='mb-1'>
            <Form.Group as={Col} md="12" controlId="association">
              <Form.Label hidden>Individual Association</Form.Label>
              <FloatingLabel controlId="association" label="Company Association" className="w-100 floating-select">

                <AsyncSelect
                  name="association"
                  className="filter-contact-association"
                  classNamePrefix="select"
                  isClearable={true}
                  //isSearchable={true}
                  cacheOptions
                  loadOptions={loadCompanyOptions}
                  defaultOptions={true}
                  value={profile.association}
                  onChange={handleCompanyAssociationChange}
                />

                {/*<Select*/}
                {/*  name="association"*/}
                {/*  className="filter-contact-association"*/}
                {/*  classNamePrefix="select"*/}
                {/*  isClearable={true}*/}
                {/*  isSearchable={true}*/}
                {/*  options={allCompanies}*/}
                {/*  value={profile.association}*/}
                {/*  onChange={handleCompanyAssociationChange}*/}
                {/*  filterOption={createFilter({ ignoreAccents: false })} //this for performance*/}
                {/*  components={{ Option: CustomOption }} //this for performance*/}
                {/*/>*/}

              </FloatingLabel>
            </Form.Group>
          </Row>

          {/*Row 7*/}
          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="addassociation2">
              <Button
                disabled={!(profile && profile.association && profile.association.value) || profile.association.value === 0}
                variant="primary"
                className="contact-add-association-button"
                onClick={addAssociation}>
                Add Company Association
              </Button>
            </Form.Group>
          </Row>

          {/*Row 8*/}
          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="association">
              <div className="association-box">
                <div className="association-title">Company Associations:</div>
                <ul>
                  {associations.map((association, index) =>
                    <li key={index} className="association-item">

                      <div className="association-item-grid">

                        <Button className="association-delete-button" title="Remove Association" onClick={() => deleteAssociation(index)}>
                          <i className="fa fa-close"></i>
                        </Button>

                        <span className={association.isDefault ? "association-is-default" : null} title={association.isDefault ? "Default Customer" : "" }>{association.label}</span>

                        {!association.isDefault ?
                          <Button className="association-default-button" title="Make Default" onClick={() => setDefaultAssociation(index)}>
                            <i className="fa fa-check"></i>
                          </Button>
                          : null}

                      </div>

                    </li>
                  )}
                </ul>
              </div>
              {(associations.length !== 0) ?
                <div className="association-list-note">{associations.length} associations found.</div>
                : null }
            </Form.Group>
          </Row>

          {/*Row 9*/}
          <Row className='mb-0'>
            <Form.Group as={Col} md="12" controlId="internalNotes">
              <Button
                variant="warning"
                style={{ borderRadius: "10px" }}
                className='mb-2'
                onClick={addInternalNotesTimeStamp}>
                <span className="me-2">
                  <i className="bi bi-alarm"></i>
                </span>
                Time Stamp
              </Button>
              <FloatingLabel controlId="internalNotes" label="Notes" className="w-100">
                <Form.Control ref={internalNotesRef} name='internalNotes' as="textarea" placeholder="Notes" value={profile.internalNotes} onChange={handleProfileChange} style={{ height: '150px' }} />
              </FloatingLabel>
            </Form.Group>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}